"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _admin = require("../../selectors/admin.js");
var _admin2 = require("../../reducers/admin.js");
var _MessagingComponent = _interopRequireDefault(require("./MessagingComponent"));
var _withMessageList = _interopRequireDefault(require("./withMessageList"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    projectLinks: (0, _admin.getProjectLinks)(state.assignment.admin),
    breadcrumbs: (0, _admin.getDeploymentBreadcrumbs)(state.assignment.admin, props),
    deployment: (0, _admin.getDeploymentById)(state.assignment.admin, props)
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  deleteMessage: _admin2.deleteMessage,
  unscheduleMessage: _admin2.unscheduleMessage,
  reloadCurrentProject: _admin2.reloadCurrentProject
})((0, _withMessageList["default"])(_MessagingComponent["default"]));